import { USER_TYPES_MAP } from 'utils/constants';

export const isStudent = (user) => user.userType === USER_TYPES_MAP.student;
export const isInstructor = (user) => user.userType === USER_TYPES_MAP.instructor;
export const isSchoolStaff = (user) => user.userType === USER_TYPES_MAP.schoolStaff;
export const isMeeoppStaff = (user) => user.userType === USER_TYPES_MAP.meeoppStaff;

export const isAllowableUserType = (user) => {
  return !(isStudent(user) || isInstructor(user));
};
